import { getLeaderboardTimeframe } from "@/sales-tools/leaderboard/api/getLeaderboardTimeframe";

import { ChecklistSummaryView } from "./ChecklistSummaryView";
import { useChecklistSummaryQuery } from "./hooks/useChecklistSummaryQuery";

export function ChecklistSummary() {
    const { start, end } = getLeaderboardTimeframe();
    const { data, isLoading } = useChecklistSummaryQuery({
        params: {
            start,
            end,
        },
    });

    return <ChecklistSummaryView stats={data} isLoading={isLoading} />;
}
